import { NgModule } from '@angular/core';
import { FileDisplayIconPipe } from './pipes/file-display-icon.pipe';
import { FileDisplayNamePipe } from './pipes/file-display-name.pipe';

@NgModule({
  exports: [FileDisplayIconPipe, FileDisplayNamePipe],
  declarations: [FileDisplayIconPipe, FileDisplayNamePipe],
})
export class FileModule {}
